import React, { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import {
    Grid,
    CardHeader,
    Card,
    CardActions,
    CardContent,
    Button,
    Typography,
    IconButton,
    Stack,

} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { societyBillSeriesService } from "../../services/SocietyBillSeriesService";
import { societyBillsService } from "../../services/SocietyBillsService";
import { SocietyBillsModel } from "../../models/SocietyBillsModel";
import fileDownload from "js-file-download";
import { SelectListModel } from "../../models/ApiResponse";
import useForm from "../../utility/hooks/UseForm";
import Controls from "../../utility/controls/Controls";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { globalService } from "../../services/GlobalService";
import { societiesService } from "../../services/SocietiesService";
import { SocietiesModel } from "../../models/SocietiesModel";
import ConfirmDialog from "../helper/ConfirmDialog";
import { Messages, ROLES } from "../../utility/Config";
import { AuthContext } from "../../utility/context/AuthContext";
import { useSharedNavigation } from "../../utility/context/NavigationContext";
import { societySubscriptionsService } from "../../services/SocietySubscriptionsService";
import { SocietyBuildingTitleModel } from "../../models/SocietyBuildingsModel";
import { societyBuildingsService } from "../../services/SocietyBuildingsService";
import BillView from "./BillView";

const SocietyBillsForMembers = (...props: any) => {
    const { auth } = React.useContext(AuthContext);
    const [title, setTitle] = useState<any>({});
    const [isBillPopupOpen, setIsBillPopupOpen] = useState(false);
    const { societyId, societyBuildingUnitId, societyMemberId }: any = useParams();
    let navigate = useNavigate();
    const [societyBills, setSocietyBills] = useState([]);
    const [billAbbreviations, setBillAbbreviations] = useState<SelectListModel[]>(
        []
    );
    const [societySubscriptionsForMember, setSocietySubscriptionsForMember] = useState<SelectListModel[]>([]);   
    ///////////
    const [societyBill, setSocietyBill] = useState<any>(null);
    //const [isMemberLoggedIn, setIsMemberLoggedIn] = React.useState(false);
    const [society, setSociety] = useState<SocietiesModel>(null);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', onConfirm: () => { } });
    const { goToHome } = useSharedNavigation();

    const handleOpen = () => {
        setIsBillPopupOpen(true);
    };

    const handleClose = () => {
        setIsBillPopupOpen(false)
    };

    const validate = (fieldValues: SocietyBillsModel = values) => {
        let temp: any = { ...errors };

        if ("BillAbbreviation" in fieldValues)
            temp.BillAbbreviation = fieldValues.BillAbbreviation
                ? ""
                : "Bill Abbreviation is required.";
        // if ("BillDate" in fieldValues)
        //   temp.BillDate = fieldValues.BillDate ? "" : "Bill Date is required.";

        setErrors({
            ...temp,
        });

        if (fieldValues === values)
            return Object.values(temp).every((x) => x === "");
    };

    const { values, setValues, errors, setErrors, handleInputChange } = useForm(
        societyBillsService.initialFieldAddSocietyBillValues,
        validate,
        societyId
    );

    const newSocietyBillSeries = () => {
        setValues(societyBillsService.initialFieldAddSocietyBillValues);
    };

    useEffect(() => {
        if (!globalService.isSocietySelected()) {
            globalService.info(Messages.SocietyUnSelected);
            return goToHome();
        }

        // setIsMemberLoggedIn(globalService.roleMatch([ROLES.Member], auth));
        // if (globalService.roleMatch([ROLES.Member], auth)) {
        getSocietySubscriptionsBySocietyId();
        getBuildingTitle();
        //}

        if (!society) getSociety();
        if (billAbbreviations.length === 0) getBillAbbreviation();
        else {
            //setIsReceiptVisible(true);
            //setIsReversalVisible(true);
            newSocietyBillSeries();
            //(SocietyCollectionReversals != true ? isReversalVisible : "")
            setErrors({});
        }
    }, [societyId]);

    const getBuildingTitle = () => {
        let model: SocietyBuildingTitleModel = {
            SocietyBuildingUnitId: societyBuildingUnitId,
            SocietyBuildingId: "",
            SocietyMemberId : societyMemberId
        }
        societyBuildingsService
            .getPageTitle(model)
            .then((response) => {
                setTitle(response.data);
            });
    };


    const getSociety = () => {
        societiesService.getById(societyId).then((response) => {
            let result = response.data;
            setSociety(result.data);
        });
    };

    //////////////////////////////////////

    const getBillAbbreviation = () => {
        societyBillSeriesService
            .getSelectListBySocietyId(societyId)
            .then((response) => {
                setBillAbbreviations(response.data);
                // if (response.data.length > 0) {
                //   values.BillAbbreviation = response.data[0].Value;
                // }
            });
    };


    const downloadBillsReceiptsPDF = (billId: any) => {
        if (!societyMemberId) {
            globalService.error('Society Member value not assigned.');
            return;
        }
        let model = {
            SocietyId: societyId,
            SocietySubscriptionId: values.SocietySubscriptionId,
            SocietyBillId: billId,
            BillAbbreviation: values.BillAbbreviation,
            SocietyMemberId: societyMemberId,
        }
        let isValidated = billId ? true : validate(); // if single bill then no validate method will be called
        if (isValidated) {
            societyBillsService.createBillsReceiptsPdf(model).then((response) => {
                let result = response.data;
                fileDownload(result, "SocietyBillsReceipts.pdf");
            });
        }
    };


    const getSocietySubscriptionsBySocietyId = () => {
        societySubscriptionsService.getSocietySubscriptionsForMobile(societyId)
            .then((response) => {
                var result = response.data;
                if (result.isSuccess) {
                    const selectList: SelectListModel[] = result.list.map((item: any) => ({
                        Text: item.AcPeriod,  // or item.Name depending on your API
                        Value: item.SocietySubscriptionId     // or item.Id
                    }));
                    setSocietySubscriptionsForMember(selectList);
                    setValues((prevValues: any) => ({
                        ...prevValues,
                        SocietySubscriptionId: selectList[0].Value,
                    }));
                    localStorage.removeItem("societySubscriptionId");
                }
                else
                    globalService.error(result.message);
            });
    };


    const handleSubmit = (e: React.FormEvent) => {
        debugger;
        e.preventDefault();
        values.SocietyId = societyId;
        let model = {
            SocietyId: societyId,
            BillAbbreviation: values.BillAbbreviation,
            SocietyBuildingUnitId: societyBuildingUnitId,
            SocietyMemberId: societyMemberId,
            SocietySubscriptionId: values.SocietySubscriptionId
        }
        if (validate()) {
            societyBillsService
                .searchBills(model)
                .then((response) => {
                    let result = response.data;
                    setSocietyBills(result.list);
                });
        }
    };

    const columns: GridColDef[] = [
        { field: "BillNo", headerName: "Bill No", width: 130, flex: 2 },
        {
            field: "BillDate", headerName: "Bill Date",
            valueFormatter: (params) => dayjs(params.value).format('DD-MMM-YYYY'),
        },
        // {
        //     field: "UAmount", headerName: "Amount", width: 130, flex: 1,
        //     headerClassName: 'header-right', cellClassName: 'cell-right',
        //     renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
        // },
        // {
        //     field: "Arrears", headerName: "Arrears", width: 130, flex: 1,
        //     headerClassName: 'header-right', cellClassName: 'cell-right',
        //     renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
        // },
        // {
        //     field: "InterestArrears",
        //     headerName: "Interest Arrears",
        //     width: 90,
        //     headerClassName: 'header-right', cellClassName: 'cell-right',
        //     renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
        // },
        // {
        //     field: "Interest", headerName: "Interest", width: 130, flex: 1,
        //     headerClassName: 'header-right', cellClassName: 'cell-right',
        //     renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
        // },
        {
            field: "Payable", headerName: "Payable", width: 130, flex: 1,
            headerClassName: 'header-right', cellClassName: 'cell-right',
            renderCell: (params) => { return globalService.formatToIndianCurrencyWithoutSymbol(params.value ?? 0) }
        },
        {
            field: "Actions",
            headerName: "Actions",
            type: "number",
            flex: 2.5,
            renderCell: (params) => {
                return (
                    <Stack direction="row" spacing={0}>
                        <Button className="btnGrid" size="small" variant="contained"
                            onClick={() => {
                                setSocietyBill(params.row)
                                handleOpen()
                            }}>View</Button>
                    </Stack >
                );
            },
        },
    ];


    return (
        <>
            <Stack direction="row" spacing={0} justifyContent="space-between">
                <Typography variant="h5" align="center">
                    Society Bills For Members 
                </Typography>
                <Typography variant="body1"><b>Member : </b>{title.SocietyMemberName}  <b>Building : </b>{title.Building}  <b>Unit :</b> {title.Unit}  </Typography>
            </Stack>
            <form noValidate onSubmit={handleSubmit}>
                <Card>
                    <CardHeader title="Billing Parameters" />
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <Controls.Select
                                    name="SocietySubscriptionId"
                                    label="Society Subscription"
                                    required
                                    showEmptyItem={false}
                                    options={societySubscriptionsForMember}
                                    value={
                                        societySubscriptionsForMember.length > 0 ? values.SocietySubscriptionId : ""
                                    }
                                    onChange={(e: any) => {
                                        handleInputChange(e);
                                        localStorage.setItem("societySubscriptionId", e.target.value);

                                        setValues((prevValues: any) => ({
                                            ...prevValues,
                                            BillAbbreviation: '',
                                            BillDate: ''
                                        }));
                                    }}
                                //error={errors.BillAbbreviation}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Controls.Select
                                    name="BillAbbreviation"
                                    label="Bill Abbreviation"
                                    required
                                    showEmptyItem={true}
                                    options={billAbbreviations}
                                    value={
                                        billAbbreviations.length > 0 ? values.BillAbbreviation : ""
                                    }
                                    onChange={(e: any) => {
                                        handleInputChange(e);
                                    }}
                                    error={errors.BillAbbreviation}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Button type="submit" variant="contained" className={!globalService.roleMatch([ROLES.ReadOnly], auth) ? '' : 'hidden'}>
                                    Go
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card>
                    <CardContent>
                        <Button
                            style={{ marginRight: "2vh" }}
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            // size="small"
                            onClick={() => downloadBillsReceiptsPDF(null)}
                        >
                            Download Bills/Receipts PDF
                        </Button>


                        <div style={{ width: "100%" }}>
                            <DataGrid
                                getRowId={(row) => row.SocietyBillId}
                                rows={societyBills}
                                columns={columns}
                                columnHeaderHeight={30}
                                //rowHeight={30}
                                autoHeight={true}
                                getRowHeight={() => "auto"}
                                getEstimatedRowHeight={() => 200}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {},
                                    },
                                    pagination: { paginationModel: { pageSize: 10 } },
                                }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                pageSizeOptions={[10, 25, 50, 100]}
                            />
                        </div>
                    </CardContent>
                </Card>
                <Stack spacing={2} direction="row" justifyContent={"center"}>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate('/societyMemberTenants')}
                    >
                        Back
                    </Button>
                </Stack>
            </form>

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
 
            {societyBill && <BillView
                open={isBillPopupOpen}
                onClose={handleClose}
                SocietyBillId={societyBill.SocietyBillId}
                BillAbbreviation={societyBill.BillAbbreviation}
                SocietyId={societyBill.SocietyId}
                SocietySubscriptionId={societyBill.SocietySubscriptionId}
            />
            }
        </>
    );
};

export default SocietyBillsForMembers;
